export const BASE_URL = process.env.PUBLIC_URL
export const APP_DOMAIN = process.env.REACT_APP_DOMAIN
export const API_URL = process.env.REACT_APP_API_URL
export const GAME_URL = process.env.REACT_APP_GAME_URL
export const moneyAddress = "0xD47d2365F08BB5935563E33C3A736Ff599998282"
export const nftAddress = "0x9B14888fA46C2Cdf85219eDB4f83e31AaB99418a"
export const publicKey = "0x9dA74236a98781Ad458eB16D28D9A21131D2e596"
export const privateKey =
  "ef02668492ab2a43928fd600db784baa2efce622fe50657cf9134c02add5a611"

export const web3ChainId = process.env.REACT_APP_WEB3_CHAIN_ID
export const web3ChainName = process.env.REACT_APP_WEB3_CHAIN_NAME
export const web3BlockExplorer = process.env.REACT_APP_WEB3_BLOCK_EXPLORER
